import { CounterpartyNameOrAliasDetail, MarketType, MasterLegalAgreementType, RepoType, SettlementVenue, ValidationIssue } from 'api'
import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { CounterpartyFilter, createCounterpartyNamesAndAliasesListDetailsSelector } from 'selectors/tradingEntitySelectors'
import { Nullable } from 'utils'
import { Combobox, ComboboxProps } from 'view/components/options'
import { getOrderCounterpartyValidationIssues } from './utils'

export type AliasesComboboxProps = OwnProps & StateProps

interface OwnProps extends Omit<ComboboxProps<string, string>, 'optionKeys'> {
  isin: string | null
  bui: string | null
  secondaryCollateralId: string | null
  secondaryBasketId: string | null
  fundId: string | null
  clearingHouseId: string | null
  masterLegalAgreementType: MasterLegalAgreementType | null
  marketType: MarketType | null
  repoType: RepoType | null
  settlementVenue: Nullable<SettlementVenue>
  validationIssues: ValidationIssue[]
}

interface StateProps {
  aliases: CounterpartyNameOrAliasDetail[]
}

interface DispatchProps {}

const filtersSelector = (_: {}, props: AliasesComboboxProps): CounterpartyFilter[] => [
  {
    isin: props.isin,
    bui: props.bui,
    secondaryCollateralId: props.secondaryCollateralId,
    secondaryBasketId: props.secondaryBasketId,
    fundId: props.fundId,
    masterLegalAgreementType: props.masterLegalAgreementType,
    repoType: props.repoType,
    marketType: props.marketType
  }
]

const counterpartyClearingHouseIdSelector = (_: {}, props: AliasesComboboxProps) => props.clearingHouseId
const counterpartySettlementVenueSelector = (_: {}, props: AliasesComboboxProps) => props.settlementVenue
const organisationIdSelector = () => null
const showAliasesSelector = () => true

const mapStateToProps = createStructuredSelector({
  aliases: createCounterpartyNamesAndAliasesListDetailsSelector(
    filtersSelector,
    counterpartySettlementVenueSelector,
    counterpartyClearingHouseIdSelector,
    organisationIdSelector,
    showAliasesSelector
  )
})

const AliasesComboboxComponent = React.forwardRef((props: AliasesComboboxProps, ref: React.Ref<Combobox>) => {
  const { aliases, onUpdate, validationIssues, value, ...comboboxProps } = props

  const comboboxValue = value ? aliases.find(a => a.alias === value || a.counterpartyId === value) : null

  const optionKeys = aliases.map(o => {
    if (o.alias) return o.alias
    return o.publishedName
  })

  const onUpdateCombobox = (optionKey: string | null) => {
    if (optionKey === null) onUpdate(null)

    const found = aliases.find(a => a.alias === optionKey || a.publishedName === optionKey)

    if (found) {
      const counterpartyId = found.counterpartyId
      const counterpartyAlias = found?.alias

      onUpdate(counterpartyAlias ? counterpartyAlias : counterpartyId)
    }
  }

  return (
    <Combobox
      {...comboboxProps}
      ref={ref}
      value={comboboxValue?.alias ?? comboboxValue?.publishedName}
      onUpdate={onUpdateCombobox}
      optionKeys={optionKeys}
      validationIssues={getOrderCounterpartyValidationIssues(validationIssues)}
    />
  )
})

export const AliasesCombobox = connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, null, null, { forwardRef: true })(
  AliasesComboboxComponent
)
